<template>
  <div class="profilinterface-list">

    <v-container grid-list-xl fluid >
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-account-box-multiple</v-icon>{{$t('administration.profil.profilinterfaces')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
            <v-btn
              class="ml-2"
              color="primary"
              v-if="userHasAccess('profilinterface_edit')"
              :to="{ name: 'ProfilInterfaceCreate' }"
            >
              {{ $t('global.add')}}
            </v-btn>
          </div>
        </v-toolbar>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.base" slot-scope="{ item }">
            <strong v-if="item.base" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>

          </v-data-table>

      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProfilInterfaceList',
  servicePrefix: 'ProfilInterface',
  mixins: [ListMixin,AccessMixin],
  components: {

  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('administration.profil.base'), value: 'base' },
        { text: this.$t('administration.profil.blocs'), value: 'blocs' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('profilinterface', {
      items: 'list'
    }),
    ...mapFields('profilinterface', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profilinterface', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
